export const getCashflowCategoriesApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `cashflow/category${queryString ? `?${queryString}` : ""}`;
};
export const addCashflowCategoriesApi = () => {
    return `/cashflow/category`;
};

export const updateCashflowCategoriesApi = (params) => {
    return `/cashflow/category`;
}; 

export const deleteCashflowCategoriesApi = (params) => {
    return `cashflow/category`;
};
export const getTransactionsApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `cashflow/transactions${queryString ? `?${queryString}` : ""}`;
};
export const addTransactionsApi = (params) => {
    return `cashflow/transactions`;
};
export const updateTransactionsApi = (params) => {
    return `cashflow/transactions`;
};
export const deleteTransactionsApi = (params) => {
    return `cashflow/transactions`;
};
export const getTransactionTypesApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `cashflow/transactions_types${queryString ? `?${queryString}` : ""}`;
};